module.exports = "/packs/images/svg/ireland/facilities/healthwise~0e4a253c682d7da2961be84b0b6f4533.svg";